import * as ActionTypes from '../constants/ActionTypes'
import { getRequest, postRequest_ } from './http'
import { baseurl } from '../constants/constants';

export function setData(items, name) {
    return {
        type: ActionTypes.SET_DATA,
        name: name,
        items: items
    }
}

export function setDataConcat(items, name) {
    return {
        type: ActionTypes.DATA_WITH_PAGINATION_CONCAT,
        name: name,
        items: items
    }
}

const get_ = (data, controller) => {
    return (dispatch) => {
        dispatch(setData({
            loading: { Msg: 'Cargando...', isOpen: true },
            response: {},
            simpleToast: false
        }));
        getRequest(data, controller).then(
            (response) => {
                if (data.typeOption == "get_reserve_room") {
                    dispatch(setData({
                        loading: { Msg: 'Cargando...', isOpen: false },
                        response: {
                            Msg: "Habitaciones encontradas",
                            redirect: false,
                            success: 1,
                            action: data.typeOption
                        },
                        simpleToast: false,
                        dataRooms: response.data
                    }));
                }
            },
            (err) => {
                dispatch(setData({
                    loading: { Msg: 'Ocurrio un error...', isOpen: false },
                }));
            }
        );
    }
};

const post_ = (data, controller) => {
    return (dispatch) => {
        dispatch(setData({
            loading: { Msg: 'Cargando...', isOpen: true },
            refresh_list: false,
            response: {},
            simpleToast: false
        }));
        postRequest_(data, controller).then(
            (response) => {
                if (data.typeOption == "update_reserve_room" || data.typeOption == "save_reserve_room") {
                    dispatch(setData({
                        response: { Msg: response.data.msg, success: response.data.success, action: data.typeOption },
                        simpleToast: true,
                        loading: { Msg: 'Cargando...', isOpen: false },
                        refresh_list: true,
                        concat_list: false,
                    }))
                }
            },
            (err) => {
                dispatch(setData({
                    loading: { Msg: 'Ocurrio un error...', isOpen: false },
                }));
            }
        );
    }
};

export default {
    get_,
    post_,
    setData
}
